import { render } from "./ArchivePage.vue?vue&type=template&id=57b075c4&scoped=true"
import script from "./ArchivePage.vue?vue&type=script&lang=js"
export * from "./ArchivePage.vue?vue&type=script&lang=js"

import "./ArchivePage.vue?vue&type=style&index=0&id=57b075c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b075c4"]])

export default __exports__